// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FbHZ","col":"styles_col__3edW3"};